<template>
    <div class="navigation">
        <button type="button" class="navigation-prev" @click="slidePrev()">
            <span></span>
        </button>
        <button type="button" class="navigation-next" @click="slideNext()">
            <span></span>
        </button>
    </div>
</template>

<script>
export default {
    methods: {
        slidePrev() {
            this.$emit('slide-prev');
        },
        slideNext() {
            this.$emit('slide-next');
        }
    }
}
</script>
